export default {
  errors: {
    cannotBeBlank: "Dit veld mag niet leeg zijn",
    required: "Dit veld is verplicht",
    somethingWentWrong: "Er is iets misgegaan. Probeer het later opnieuw.",
  },
  logs: {
    time: "Tijd",
    username: "Gebruikersnaam",
    role: "Rol",
    terminalID: "Terminal-ID",
    moduleAccessed: "Toegang tot module",
    typeOfAccess: "Type toegang",
    activityLogDetails: "Details van activiteitenlogboek",
    userId: "Gebruikers-ID",
    lastLogin: "Laatste login",
    geoAccPoint: "Geografisch toegangspunt",
    ipAdd: "IP-adres",
    filesAccessed: "Geopende bestanden",
    funAccessed: "Toegang tot functie",
    webUrl: "Web-URL",
    unsuccAtmp: "Mislukte inlogpogingen",
    view: "Bekijken",
    membershipType: "Lidmaatschapstype",
  },
  validation: {
    exporterRequired: "Het veld Exporteur is verplicht",
    importerRequired: "Het veld Importeur is verplicht",
    portOfOriginRequired: "Het veld Haven van Oorsprong is verplicht",
    containerSizeNumber: "Het veld Containergrootte moet een nummer zijn",
    containerCapacityNumber:
      "Het veld Containercapaciteit moet een nummer zijn",
  },
};
